import React from "react";
import Modal from "react-modal";
import CloseModalButton from "../controls/CloseModalButton";
import Header from "../boxes/Header";
import Icon from "../general/Icon";
import { AuthProvider } from "../../types/user";
import { DigiAuthState } from "../../hooks/digiAuth";
import { t } from "../../i18n";

const ControlCode = ({ code }: { code: string }): JSX.Element | null => {
  if (!code) return null;
  const text = t("mobile_id.control_message.code", { code });
  return <p className="u-mt-20" dangerouslySetInnerHTML={{ __html: text }}/>;
}

interface Props {
  state: DigiAuthState;
  i18nTitle: string;
  onClose?: VoidFunction;
  onSuccess: VoidFunction;
  provider: AuthProvider;
}

const DigiAuthModal = (props: Props): JSX.Element | null => {
  const { i18nTitle, onClose, onSuccess, provider, state } = props;

  if(state.status === "success") {
    onSuccess();
    return null;
  }

  return (
    <Modal
      appElement={document.getElementById("react-root")!}
      className="Modal u-p-60 mz-mobile-id-modal"
      isOpen={state.status !== "idle" && state.status !== "starting"}
      overlayClassName="Modal-overlay"
    >
      {state.status === "error" && <CloseModalButton onClick={onClose}/>}
      <Header className="text-xl-bold" level="2" i18nKey={i18nTitle}/>
      <div className="mz-mobile-id-modal__content">
        {state.status === "running" && (
          <>
            <Icon className="mz-mobile-id-modal__info-icon" rotating symbolId="progress-circle"/>
            <p>{t(`auth.${provider}.modal.text`)}</p>
          </>
        )}
        {state.status === "error" && (
          <>
            <Icon className="mz-mobile-id-modal__info-icon" symbolId="error"/>
            <p>{state.message}</p>
          </>
        )}
      </div>
      {state.status === "running" && <ControlCode code={state.controlCode}/>}
      <div className="u-text-right">
      </div>
    </Modal>
  )
}

export default DigiAuthModal;
